module.exports = __webpack_public_path__ + "240e2448dd01492079a48ecf59524ebc.jpg";